import axios from 'axios'
import { GET_INCOMING_LOGS_URL } from './consts'

export const getIncomingLogs = () => {
  return axios.get(GET_INCOMING_LOGS_URL, {
    responseType: 'blob',
  })
}
